import { StoreonModule } from "storeon";
import { Address } from "./models/Address";
import { Person } from "./models/Person";
import { Gender } from "./enums/Gender";

export interface ISubscriberStore {
  subscriberStore: ISubscriberStoreShape
};

export interface ISubscriberStoreShape {
    subscriberInfo: Person;
    homeAddress: Address;
    homePhone: string;
    email: string;
    mailingAddress: Address;
    mailingPhone: string | undefined;
    isMailingSameAsHome: boolean;
    donateLifeOptIn: boolean | undefined;
};

export interface ISubscriberEvents {
  setFirstName: string;
  setMiddleName: string;
  setLastName: string;
  setSuffix: string;
  setGender: Gender;
  setBirthDate: Date;
  setSSN: string;

  setEmail: string;

  setHomeAddress1: string;
  setHomeAddress2: string;
  setHomeCity: string;
  setHomeState: string;
  setHomeCounty: string;
  setHomeZip: string;
  setHomePhone: string;

  setMailingAddress1: string;
  setMailingAddress2: string;
  setMailingCity: string;
  setMailingState: string;
  setMailingCounty: string;
  setMailingZip: string;
  setMailingPhone: string;

  toggleIsMailingSameAsHome: undefined;
  
  setDonateLifeOptIn: boolean;
};

const subscriberStore: StoreonModule<ISubscriberStore, ISubscriberEvents> = (store) => {
  store.on('@init', initializeSubscriber)

  store.on('setFirstName', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      subscriberInfo: {
        ...state.subscriberStore.subscriberInfo,
        firstName: event,
      },
    },
  }))
  store.on('setMiddleName', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      subscriberInfo: {
        ...state.subscriberStore.subscriberInfo,
        middleName: event,
      },
    },
  }))
  store.on('setLastName', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      subscriberInfo: {
        ...state.subscriberStore.subscriberInfo,
        lastName: event,
      },
    },
  }))
  store.on('setSuffix', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      subscriberInfo: {
        ...state.subscriberStore.subscriberInfo,
        suffix: event,
      },
    },
  }))
  store.on('setGender', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      subscriberInfo: {
        ...state.subscriberStore.subscriberInfo,
        gender: event,
      },
    },
  }))
  store.on('setBirthDate', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      subscriberInfo: {
        ...state.subscriberStore.subscriberInfo,
        birthDate: event,
      },
    },
  }))
  store.on('setSSN', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      subscriberInfo: {
        ...state.subscriberStore.subscriberInfo,
        ssn: event,
      },
    },
  }))
  store.on('setEmail', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      email: event,
    },
  }))

  store.on('setHomeAddress1', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      homeAddress: {
        ...state.subscriberStore.homeAddress,
        address1: event,
      },
    },
  }))
  store.on('setHomeAddress2', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      homeAddress: {
        ...state.subscriberStore.homeAddress,
        address2: event,
      },
    },
  }))
  store.on('setHomeCity', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      homeAddress: {
        ...state.subscriberStore.homeAddress,
        city: event,
      },
    },
  }))
  store.on('setHomeCounty', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      homeAddress: {
        ...state.subscriberStore.homeAddress,
        county: event,
      },
    },
  }))
  store.on('setHomeState', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      homeAddress: {
        ...state.subscriberStore.homeAddress,
        state: event,
      },
    },
  }))
  store.on('setHomeZip', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      homeAddress: {
        ...state.subscriberStore.homeAddress,
        zip: event,
      },
    },
  }))
  store.on('setHomePhone', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      homePhone: event,
    },
  }))
  store.on('setMailingAddress1', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      mailingAddress: {
        ...state.subscriberStore.mailingAddress,
        address1: event,
      },
    },
  }))
  store.on('setMailingAddress2', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      mailingAddress: {
        ...state.subscriberStore.mailingAddress,
        address2: event,
      },
    },
  }))
  store.on('setMailingCity', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      mailingAddress: {
        ...state.subscriberStore.mailingAddress,
        city: event,
      },
    },
  }))
  store.on('setMailingCounty', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      mailingAddress: {
        ...state.subscriberStore.mailingAddress,
        county: event,
      },
    },
  }))
  store.on('setMailingState', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      mailingAddress: {
        ...state.subscriberStore.mailingAddress,
        state: event,
      },
    },
  }))
  store.on('setMailingZip', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      mailingAddress: {
        ...state.subscriberStore.mailingAddress,
        zip: event,
      },
    },
  }))
  store.on('setMailingPhone', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      mailingPhone: event,
    },
  }))

  store.on('toggleIsMailingSameAsHome', (state) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      isMailingSameAsHome: !state.subscriberStore.isMailingSameAsHome
    },
  }))

  store.on('setDonateLifeOptIn', (state, event) => ({
    ...state,
    subscriberStore: {
      ...state.subscriberStore,
      donateLifeOptIn: event,
    },
  }))
}

export const initializeSubscriber = (): ISubscriberStore => ({
  subscriberStore: {
    subscriberInfo: {
      firstName: '',
      middleName: '',
      lastName: '',
      suffix: '',
      gender: undefined,
      birthDate: new Date(''),
      ssn: ''
    },
    homeAddress: {
      address1: '',
      address2: '',
      city: '',
      state: '',
      county: '',
      zip: '',
    },
    homePhone: '',
    email: '',
    mailingAddress: {
      address1: '',
      address2: '',
      city: '',
      state: '',
      county: '',
      zip: '',
    },
    mailingPhone: undefined,
    isMailingSameAsHome: false,
    donateLifeOptIn: undefined,
  }
})

export default subscriberStore;